/**
 * 날짜 포맷 변환 유틸
 * - 화면/폼 표시용: yyyy.mm.dd
 * - API 전송/응답용: yyyy-mm-dd
 */

/** 폼 표시용(yyyy.mm.dd) → API용(yyyy-mm-dd) */
export const toApiDate = (formDate?: string | null): string =>
  formDate ? String(formDate).replaceAll('.', '-') : '';

/** API용(yyyy-mm-dd) → 폼 표시용(yyyy.mm.dd) */
export const toFormDate = (apiDate?: string | null): string =>
  apiDate ? String(apiDate).replaceAll('-', '.') : '';
